import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_URL;

const getHeaders = (isFormData = false) => ({
  "Content-Type": isFormData ? "multipart/form-data" : "application/json",
  Authorization: `Bearer ${localStorage.getItem("jwt_token")}`,
});

/* ---------------- GET PDFs ---------------- */

export const fetchAcFormate = createAsyncThunk(
  "acFormate/fetchAcFormate",
  async (_, thunkAPI) => {
    try {
      const res = await axios.get(`${BASE_URL}/ac-format`, {
        headers: getHeaders(),
      });

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ---------------- UPLOAD PDF ---------------- */

export const uploadAcFormate = createAsyncThunk(
  "acFormate/uploadAcFormate",
  async (data, thunkAPI) => {
    try {
      const res = await axios.post(`${BASE_URL}/ac-format`, data, {
        headers: getHeaders(true),
      });

      return res.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

/* ---------------- SLICE ---------------- */

const acFormateSlice = createSlice({
  name: "acFormate",
  initialState: {
    acFormateList: [],
    loading: false,
    uploadLoading: false,
    error: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder

      /* -------- FETCH AC Formate -------- */
      .addCase(fetchAcFormate.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAcFormate.fulfilled, (state, action) => {
        state.loading = false;
        state.acFormateList = action.payload;
      })
      .addCase(fetchAcFormate.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------- UPLOAD PDF -------- */
      .addCase(uploadAcFormate.pending, (state) => {
        state.uploadLoading = true;
        state.error = null;
      })
      .addCase(uploadAcFormate.fulfilled, (state, action) => {
        state.uploadLoading = false;

        if (action.payload?.data) {
          state.pdfList.unshift(action.payload.data);
        }
      })
      .addCase(uploadAcFormate.rejected, (state, action) => {
        state.uploadLoading = false;
        state.error = action.payload;
      });
  },
});

export default acFormateSlice.reducer;